import React, {Component} from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import {login, resetPassword, clearResult, clearLoginResult, validateToken,requestPwEmail} from '../action/userActions'
import '../../css/ewLogin.css'
import {Button, Form, Card, Col, Modal, Row, Alert} from 'react-bootstrap'


class RequestPwChange extends Component {
    constructor(props){
        super(props)
      
        this.state = {userName  : ''}
    }

    render(){
        return  <Form hidden={this.props.loading} style={{margin : '10px'}} onSubmit={(e)=>{
            e.preventDefault()
            e.stopPropagation()
            
            this.props.dispatch(requestPwEmail({userName : this.state.userName}))
        }}>
                 <h3>
    Forgot Password
</h3>

                <Form.Row >
                    <Form.Group as={Col} controlId="formGridEmail">
                        <Form.Label></Form.Label>
                        <Form.Control 
                        className={'login'}
                        required 
                        defaultValue={this.state.userName}
                        ref ={a=> this.a =a}
                        onChange={((e)=>{this.setState({userName : e.target.value},()=> this.a.focus() )})} type="email" placeholder="Enter email" />
                    </Form.Group>

                </Form.Row>
                
                
                <Button style={{backgroundColor : '#015daa'}} className='loginBtn' type='submit' disabled={this.state.userName.length == 0} >
                Send Email
                </Button>
                
        </Form>
    }
}

const mapStateToProps = state =>({
    user : state.acct.user.loggedInUser,
    loading : state.acct.user.loading,
})

export default withRouter(connect(mapStateToProps)(RequestPwChange))